<!-- src/App.vue -->
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter, RouterLink, RouterView } from 'vue-router'
import { setToken } from './api/client'

const router = useRouter()
const logged = ref(!!localStorage.getItem('ctv_token'))

function syncAuth() 
{
  logged.value = !!localStorage.getItem('ctv_token')
}

function logout() 
{
  localStorage.removeItem('ctv_token')
  localStorage.removeItem('ctv_account')
  setToken(null)
  window.dispatchEvent(new Event('auth-changed'))
  router.replace('/login')
}

onMounted(() => 
{
  window.addEventListener('auth-changed', syncAuth)
  window.addEventListener('storage', syncAuth)
})

onBeforeUnmount(() => 
{
  window.removeEventListener('auth-changed', syncAuth)
  window.removeEventListener('storage', syncAuth)
})
</script>

<template>
  <!-- <header class="header fixed">
    <div class="brand">
      <RouterLink to="/" class="brand-link">Home</RouterLink>
    </div>

    <nav class="header-actions">
      <RouterLink v-if="!logged" class="btn btn-outline" to="/login">Đăng nhập</RouterLink>
      <button v-else class="btn btn-outline" @click="logout">Đăng xuất</button>
    </nav>
  </header> -->

  <RouterView />
</template>
